import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SentryTraceInterceptor } from './sentry-trace.interceptor';

/**
 * Module providing enhanced Sentry monitoring capabilities
 *
 * Features:
 * - HTTP request/response tracking
 * - User interaction tracking
 * - Router navigation tracking
 * - Custom span creation for operations
 *
 * @example
 * @NgModule({
 *   imports: [SentryMonitoringModule],
 * })
 * export class AppModule {}
 */
@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryTraceInterceptor,
      multi: true,
    },
  ],
})
export class SentryMonitoringModule {}
